import { toast } from "react-toastify";

import { createAsyncThunk } from "@reduxjs/toolkit";

import { setLogos } from "./helpers";
import { IColorSettings } from "./types";
import {
  deleteFavicon,
  deleteIcon,
  deleteLogo,
  deleteStartPagePicture,
} from "../../constants/localStorageKeys";
import {
  getColorSettings,
  restoreColorSettings,
  updateColorSettings,
} from "../../helpers/backend_helper";
import { customPalette } from "../../themes/palette";

export const getColorSettingsThunk = createAsyncThunk<
  IColorSettings,
  void,
  { rejectValue: Error }
>("colorSettings/getColorSettings", async (_, { rejectWithValue }) => {
  try {
    const colors = await getColorSettings("colors");
    const logo = await getColorSettings("logo");
    const icon = await getColorSettings("icon");
    const favicon = await getColorSettings("favicon");
    const startPagePicture = await getColorSettings("startpagepicture");
    setLogos(logo, icon, favicon, startPagePicture);
    return {
      ...colors,
      logo: logo?.size ? logo : null,
      icon: icon?.size ? icon : null,
      favicon: favicon?.size ? favicon : null,
      startPagePicture: startPagePicture?.size ? startPagePicture : null,
    };
  } catch (error) {
    console.error("Error fetching color settings", error);
    return rejectWithValue(error as Error);
  }
});

export const updateColorSettingsThunk = createAsyncThunk<
  IColorSettings,
  {
    formData: FormData;
    logo: File;
    icon: File;
    favicon: File;
    startPagePicture: File;
  },
  { rejectValue: Error }
>("colorSettings/updateColorSettings", async (payload, { rejectWithValue }) => {
  try {
    const colors = await updateColorSettings(payload.formData);
    setLogos(
      payload.logo,
      payload.icon,
      payload.favicon,
      payload.startPagePicture
    );
    toast.success("Color settings were updated");
    return {
      ...colors,
      logo: payload.logo?.size ? payload.logo : null,
      icon: payload.icon?.size ? payload.icon : null,
      favicon: payload.favicon?.size ? payload.favicon : null,
      startPagePicture: payload.startPagePicture?.size
        ? payload.startPagePicture
        : null,
    };
  } catch (error) {
    console.error("Error updating color settings", error);
    return rejectWithValue(error as Error);
  }
});

export const restoreColorSettingsThunk = createAsyncThunk<
  IColorSettings,
  void,
  { rejectValue: Error }
>("colorSettings/restoreColorSettings", async (_, { rejectWithValue }) => {
  try {
    const colors = await restoreColorSettings();
    toast.success("Color settings were restored");
    return colors;
  } catch (error) {
    console.error("Error restoring color settings", error);
    return rejectWithValue(error as Error);
  }
});

export const resetColorSettingsThunk = createAsyncThunk<
  IColorSettings,
  void,
  { rejectValue: Error }
>("colorSettings/resetColorSettings", async () => {
  deleteFavicon();
  deleteLogo();
  deleteIcon();
  // deleteStartPagePicture();
  return {
    primaryGeneralColor: customPalette.primary.main,
    secondaryGeneralColor: customPalette.secondary.main,
    primaryTextColor: customPalette.text.primary,
    secondaryTextColor: customPalette.text.secondary,
    errorTextColor: customPalette.error.main,
    generalBackgroundColor: customPalette.background.default,
    logo: null,
    icon: null,
    favicon: null,
    startPagePicture: null,
  };
});
